import en from './translations/en.json'
import ro from './translations/ro.json'
import fr from './translations/fr.json'

export const dateLocales = { ro: 'ro-RO', en: 'en-GB', fr: 'fr-FR' }

export default {
    en, ro, fr
}
